<template>
  <section class="payment_sec page-blockui">
    <div class="container h-100">
      <div class="row h-100">
        <div class="col-lg-6 m-auto">
          <div class="payment_box">
              <div class="payment_box_inn">
                <a class="logonew" href="#"><img :src="`${publicPath}images/logo.svg`"></a>
                <div class="toptransition">
                  <div class="toptransitiontext">
                    <p class="merchant_name">{{name}}</p>
                    <p class="tranx_id">#{{ paymentId }}</p>
                  </div>
                  <img width="65px" style="width: 65px" class="pl-1" :src="avatar">
                </div>
                <h2>Avaliable Payment Methods</h2>

                <div class="container mt-3 ">
                  <div class="row payment-options">
                    <template v-for="(item,index) in avaliableMethods.sort((a, b) => a.type - b.type)">
                      <div v-if="item.type ==1 " class="col-12">
                        <div class="card option " data-payment="credit-card" @click="selectedMethod(item.referenceId,item.type)">
                          <div class="card-body d-flex justify-content-between align-items-center">
                            <span class="text">{{item.name}}</span>
                            <span class="icons">
            <img :src="`${publicPath}images/methods/Mastercard-Logo.wine.svg`" style="margin-right: -5px" alt="Mastercard" class="icon">
     <img :src="`${publicPath}images/methods/amex-card.svg`" style="margin-right: -8px" alt="Amex" class="icon">
            <img :src="`${publicPath}images/methods/Visa_Inc.-Logo.wine.svg`" alt="Visa" class="icon">
          </span>
                          </div>
                        </div>
                      </div>
                      <div  v-else-if="item.type == 3" class="col-12">
                        <div class="card option " data-payment="paypal" @click="selectedMethod(item.referenceId,item.type)" >
                          <div v-if="showGpay" style="display: none">
                           <google-pay-button
                               ref="googlePayButton"
                               environment="TEST"
                               button-type="pay"
                               button-color="black"
                               :paymentRequest="computedPaymentRequest"
                               v-on:loadpaymentdata="onLoadPaymentData"
                               v-on:error="onError"
                           ></google-pay-button>
                         </div>
                          <div class="card-body d-flex justify-content-between align-items-center" >
                            <span class="text">{{item.name}}</span>
                            <span class="icons">
            <img :src="`${publicPath}images/methods/Google_Pay-Logo.wine.svg`" alt="Google Pay" class="icon">
          </span>
                          </div>
                        </div>
                      </div>
                      <div  v-else-if="item.type == 2" class="col-12">
                        <div class="card option " data-payment="apple-pay" @click="selectedMethod(item.referenceId,item.type)">
                          <div class="card-body d-flex justify-content-between align-items-center">
                            <span class="text">{{item.name}}</span>
                            <span class="icons">
            <img :src="`${publicPath}images/methods/Apple_Pay-Logo.wine.svg`" alt="Apple Pay" class="icon">
          </span>
                          </div>
                        </div>
                      </div>
                    </template>

                  </div>
                </div>
              </div>
            <div class="cardview">
              <img width="100px" :src="`${publicPath}images/american-express.svg`">
              <img width="100px" :src="`${publicPath}images/mastercard.svg`">
              <img width="100px" :src="`${publicPath}images/visa2.svg`">
            </div>
            <hr class="linehr mt-5">
            <div class="tearm_sec  pl-3 pr-3 pb-0">
              <img width="80px" style="width: 80px" :src="`${publicPath}images/sectigo_trust_seal.png`">
              <p><a href="#"><img width="40px" style="width: 40px" :src="`${publicPath}images/logo.svg`"></a></p>
            </div>
            <div class="pb-1 m-auto">
              <p class="text-center"><small>You agree to <a target="_blank" href="https://vaultspay.com/terms-and-condition">Our Terms</a> and <a target="_blank" href="https://vaultspay.com/privacy-policy">Privacy
                Policy</a></small></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <div v-show="loader" class="blockUI" style="display:none"></div>
  <div v-show="loader" class="blockUI blockOverlay"
       style="z-index: 1000; border: none; margin: 0px; padding: 0px; width: 100%; height: 100%; top: 0px; left: 0px; background-color: rgb(0, 0, 0); opacity: 0.5; cursor: wait; position: fixed;"></div>
  <div v-show="loader" class="blockUI blockMsg blockPage"
       style="z-index: 1011; position: fixed; padding: 0px; margin: 0px; width: 30%; top: 40%; left: 35%; text-align: center; color: rgb(255, 255, 255); border: 0px; background-color: transparent; cursor: wait;">
    <div class="d-flex justify-content-center align-items-center"><p class="mr-50 mb-0">Please wait request is processing...</p>
      <div class="spinner-grow spinner-grow-sm text-white" role="status"></div>
    </div>
  </div>
</template>

<script>
import "@google-pay/button-element";
import reCaptchaMixin from "@/mixins/reCaptchaMixin";

export default {
  mixins: [reCaptchaMixin],
  computed: {
    computedPaymentRequest() {
      return JSON.parse(JSON.stringify(this.info))
    },
  },
  mounted() {

    this.paymentId = typeof (this.$route.query.paymentId) != 'undefined' ? this.$route.query.paymentId : ''
    this.mt = typeof (this.$route.query.mt) != 'undefined' ? this.$route.query.mt : ''
    this.checkPaymentLink()

  },
  data() {
    return {
      mt:'',
      showGpay:false,
      paymentId: '',
      referenceId: '',
      loader:false,
      name:'',
      amount:0,
      currencyCode:'',
      countryCode:'AE',
      avatar:'',
      avaliableMethods:[],
      info:{
        apiVersion: 2,
        apiVersionMinor: 0,
        allowedPaymentMethods: [
          {
            type: 'CARD',
            parameters: {
              allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
              allowedCardNetworks: ['AMEX', 'VISA', 'MASTERCARD']
            },
            tokenizationSpecification: {
              type: 'PAYMENT_GATEWAY',
              parameters: {
                gateway: 'example',
                gatewayMerchantId: 'exampleGatewayMerchantId'
              }
            }
          }
        ],
        transactionInfo: {
          totalPriceStatus: 'FINAL',
          totalPriceLabel: 'Total',
          totalPrice: '100.00',
          currencyCode: 'USD',
          countryCode: 'US'
        }
      }

    }
  },
  methods: {
    async onLoadPaymentData(event) {
      let paymentData = event.detail;
      const paymentToken = paymentData.paymentMethodData.tokenizationData.token;
      let data = {
        referenceId : this.referenceId,
        paymentMethodTokenData: JSON.parse(paymentToken)
      }

      this.loader = true

      if(process.env.VUE_APP_ACTIVATE_RECAPTCHA == 'true'){
        try {
          const token = await this.executeRecaptcha('submit');
          this.recaptchaToken = token;

        } catch (error) {
          console.error('reCAPTCHA error:', error);
        }

        data = {
          ...data,
          verResponse: this.recaptchaToken,
          resId: Date.now()
        }
      }

      // Send the payment token to backend to complete the payment process
      const callResponse = await  this.makeRequest('post', 'v1/process-payment-link', data,{},false)
      this.loader = false
      if (!callResponse.error) {
        let code = callResponse.response.data.code;

        if (code == 200) {
          let data = callResponse.response.data.data
          if(data.bypass3DS){
            localStorage.setItem('transaction-payment-details',JSON.stringify(data));
            this.$router.replace({name:'payment-success',query: { txnId: data.transactionId }})
          }else{
            this.redirect(data.paymentUrl)
          }

        }else{
          localStorage.setItem('errorMessage',callResponse.response.data.message);
          this.$router.push({name:'payment-failed'})
        }
      }
    },
    onError(event) {
      this.loader = false
      console.error("error", event.error);
    },
    startApplePay() {
      // return
      if (!window.ApplePaySession) {
        alert('Apple Pay is not supported on this device');
        return;
      }

      const paymentRequest = {
        countryCode: this.countryCode,
        currencyCode: this.currencyCode,
        supportedNetworks: ['visa', 'masterCard', 'amex'],
        merchantCapabilities: ['supports3DS', 'supportsCredit', 'supportsDebit'],
        total: {
          label: this.name,
          amount: this.amount,
        },
      };

      const session = new ApplePaySession(3, paymentRequest);

      // 3. Add event handlers for Apple Pay session
      session.onvalidatemerchant = async event => {
        const merchantSession = await this.validateMerchant(event.validationURL);
        try {
          return session.completeMerchantValidation(merchantSession);
        } catch (error) {
          console.error("Error during merchant validation", error);
        }
      };

      session.onpaymentauthorized = (event) => {
        // Handle payment authorization here
        const payment = event.payment;
        // Send payment.token to your server to process the payment
        this.processPayment(payment.token)
            .then((callResponse) => {
              if (!callResponse.error) {
                let code = callResponse.response.data.code;

                if (code == 200) {
                  session.completePayment(ApplePaySession.STATUS_SUCCESS)
                  let data = callResponse.response.data.data
                  if(data.bypass3DS){
                    localStorage.setItem('transaction-payment-details',JSON.stringify(data));
                    this.$router.replace({name:'payment-success',query: { txnId: data.transactionId }})
                  }else{
                    this.redirect(data.paymentUrl)
                  }


                }else{
                  session.completePayment(ApplePaySession.STATUS_FAILURE)
                  localStorage.setItem('errorMessage',callResponse.response.data.message);
                  this.$router.push({name:'payment-failed'})
                }
              }
            })
            .catch(() => session.completePayment(ApplePaySession.STATUS_FAILURE));
      };

      session.begin();
    },
    async validateMerchant(validationURL) {
      // const response = await axios.get('https://phpstack-775760-2639124.cloudwaysapps.com/public/log');
      let data = {
        initSession:'applepay-session',
        referenceId: this.referenceId
      }
      const callResponse = await this.makeRequest('post', 'v1/transaction-url-details', data, {}, false);
      return callResponse.response.data.data
    },

    async processPayment(paymentToken) {
      let data = {
        referenceId : this.referenceId,
        paymentMethodTokenData: paymentToken?.paymentData
      }

      if(process.env.VUE_APP_ACTIVATE_RECAPTCHA == 'true'){
        try {
          const token = await this.executeRecaptcha('submit');
          this.recaptchaToken = token;

        } catch (error) {
          console.error('reCAPTCHA error:', error);
        }

        data = {
          ...data,
          verResponse: this.recaptchaToken,
          resId: Date.now()
        }
      }

      // Send the payment token to backend to complete the payment process
      const callResponse = await  this.makeRequest('post', 'v1/process-payment-link', data,{},false)
      return callResponse
    },
    async selectedMethod(paymentId, type){
      this.referenceId = paymentId
      localStorage.setItem('firstPaymentId',this.paymentId);
      localStorage.setItem('selectedMethodType',type);
      if(type == 2){
        this.startApplePay()
        return
      }else if(type == 3){
        if(this.showGpay){
          return
        }
        var res = await this.getGpayCredentials(this.referenceId)
        this.info = {
          apiVersion: 2,
          apiVersionMinor: 0,
          allowedPaymentMethods: [
            {
              type: 'CARD',
              parameters: {
                allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
                allowedCardNetworks: ['AMEX', 'VISA', 'MASTERCARD']
              },
              tokenizationSpecification: {
                type: 'PAYMENT_GATEWAY',
                parameters: {
                  gateway: atob(res.ref),
                  gatewayMerchantId: res.refId
                }
              }
            }
          ],
          merchantInfo: {
            merchantId: res.id,
            merchantName: this.name,
          },
          transactionInfo: {
            totalPriceStatus: 'FINAL',
            totalPriceLabel: 'Total',
            totalPrice: this.amount.toString(),
            currencyCode: this.currencyCode,
            countryCode: 'AE'
          }
        }
        this.showGpay =true
        setTimeout(()=>{
          document.getElementById('gpay-button-online-api-id').click()
        },2000)
        return
      }
      this.$router.push({name: 'merchant-payment', query : { paymentId: paymentId}});
    },
    async getGpayCredentials(referenceId){
      this.loader = true
      let data = {
        initSession:'googlepay-session',
        referenceId: referenceId
      }
      const callResponse = await this.makeRequest('post', 'v1/transaction-url-details', data, {}, false);
      this.loader = false
      return callResponse.response.data.data
    },
    async checkPaymentLink(){
      let data = {}
      data.paymentId = this.paymentId
      if(this.mt != ''){
        data.mtype = this.mt
      }

      this.loader = true

      // if(process.env.VUE_APP_ACTIVATE_RECAPTCHA == 'true'){
      //   try {
      //     this.recaptchaToken = await this.executeRecaptcha('submit');
      //
      //   } catch (error) {
      //     console.error('reCAPTCHA error:', error);
      //   }
      //
      //   data = {
      //     ...data,
      //     verResponse: this.recaptchaToken,
      //     resId: Date.now()
      //   }
      // }

      this.makeRequest('post', 'v1/check-payment-link', data,{},false).then(callResponse => {

        this.loader = false
        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            let data = callResponse.response.data.data
            this.avaliableMethods = data.methods
            localStorage.setItem('checkPaymentData',JSON.stringify(data));
            if(this.avaliableMethods.length == 1){
              localStorage.setItem('selectedMethodType',this.avaliableMethods[0].type);
              // skip if apple pay or gpay
              if (![2, 3].includes(this.avaliableMethods[0].type)) {
                this.selectedMethod(this.avaliableMethods[0].referenceId,this.avaliableMethods[0].type)
                return
              }
            }
            this.name = data.details.name
            this.avatar = data.details.avatar
            this.amount = parseFloat(data.details.amount) / 100
            this.currencyCode = data.details.currency

            if(this.avaliableMethods.length > 0){
              this.avaliableMethods.forEach(element => {
                if(element.type == 3){
                  // this.getGpayCredentials(element.referenceId)
                }
              })
            }




          }
        }

      });
    },
  }
}
</script>


